define("Ames.RentFromAnywhere.RentFromAnywhere.MyAccount", [
  "jQuery",
  "Utils",
  "LiveOrder.Model",
  "Ames.RentFromAnywhere.RentalOrder.History.View",
  "Transaction.Line.Views.Cell.Actionable.View.Extension",
  "OrderHistory.Details.View.Extension",
  "OrderHistory.Collection.Ext",
  "OrderHistory.Item.Actions.View.Extension"
], function (
  jQuery,
  Utils,
  LiveOrderModel,
  RentalOrdersView,
  TransactionLineViewsCellActionableViewExtension,
  OrderHistoryDetailsViewExtension,
  OrderHistoryCollectionExt,
  OrderHistoryItemActionsViewExtension
) {
  "use strict";

  return {
    mountToApp: function (container) {
      var layout = container.getComponent("Layout");
      var pdp = container.getComponent("PDP");
      var checkout = container.getComponent("Checkout");
      var myaccount = container.getComponent("MyAccount");
      this.liveOrderInstance = LiveOrderModel.getInstance();
      
      var PageType = container.getComponent("PageType");

      if (!checkout && !pdp) {
        var MyAccountMenuComponent = container.getComponent("MyAccountMenu");
        var rentalOrdersMenuGroup = {
          id: "rentalorders",
          name: "Rental Order History",
          index: 6,
          url: "rental-orders",
        };
        MyAccountMenuComponent.addGroup(rentalOrdersMenuGroup);

        PageType.registerPageType({
          name: "rentalorders",
          routes: ["rental-orders"],
          view: RentalOrdersView,
          options: {
            application: container,
          },
          defaultTemplate: {
            name: "tavano_ttrentalorders_rentalorders.tpl",
            displayName: "Rental Orders Page",
          },
        });
      }

      if (!layout || !pdp) {
        return;
      }
    },
  };
});
